/**
 * Результат выполнения processQueryResults
 * @typedef {Object} ProcessedResult
 * @property {Object[]} data - Массив данных
 * @property {boolean} isLoading - `true`, если хотя бы один запрос ещё обрабатывается
 */
/**
 * Возвращает массив с результатами запросов и общий isLoading для всех этих запросов
 * @param {Object[]} results - результат выполнения хука useReques
 * @returns {ProcessedResult}
 */
export function processQueryResults(results) {
  const emptyResult = { data: [] };

  if (!Array.isArray(results)) {
    console.warn('[processQueryResults] Provided argument is not an array, returning empty result');
    return emptyResult;
  }

  return results.reduce((acc, queryResult) => {
    acc.data.push(queryResult.data);
    if (queryResult.isLoading) acc.isLoading = true;
    return acc;
  }, emptyResult);
}

/**
 * Проверяет наличие history в прокидываемых параметрах, при отсутствии - отбрасываем ошибку
 * @property {Object} params - Query-параметры
 * @property {String} queryType - Название Query-функции
 */
export function throwIfHistoryIsMissing(params, queryType) {
  if (!params?.history && !params.renderError) throw new Error(`History was not passed to ${queryType}`);
}
